import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_13: FaireProductEntity = {
  token: "viverano-13",
  type: "product",
  name: "Veggie Baby Sleep Sack & Wearable Blanket (Organic Cotton)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/c9b937ca1ad91a8d458546a028566b5c9bc9fe1483abdf6c69e4bf6035731933.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1068,1067,x320,y0,safe&width=720",
  priceDollars: 28,
  msrpDollars: 48,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
